import Swiper from 'swiper';
import SwiperCore, { Autoplay, Pagination, Navigation } from 'swiper/core';
// configure Swiper to use modules
SwiperCore.use([Autoplay, Pagination, Navigation]);

const slideshow = function(next) {

	const sliders = next.container.querySelectorAll('.swiper')

	if (sliders.length === 0)
		return

	sliders.forEach(slider => {

		const speed = 2000
		const swiper = new Swiper(slider, {
			loop: true,
			// effect: 'fade',
			cssMode: true,
			pagination: {
				type: 'fraction',
				el: ".swiper-custom-pagination",
			},
			navigation: {
				nextEl: '.swiper-next',
				prevEl: '.swiper-prev',
			},
			speed: (speed / 2),
			on: {
				slideChange: function(swiper) {
					const caption = swiper.slides[swiper.activeIndex].dataset.caption
					const captionEl = swiper.wrapperEl.nextElementSibling.querySelector('.slideshow-caption')

					if (captionEl) {
						captionEl.innerHTML = caption
					}
				}
			}
		})

	})

}

export default slideshow
